import queryString from 'query-string';
import { createFilterQueryString } from '@features/table/utils/createFilterQueryString';
import type { TGetParams } from '@shared/models/queryParams.model';

const generateStringWithQueryParams = (
  { limit, offset, orderBy, order, filters }: TGetParams,
  options: {
    defaultOrderBy?: string;
  } = {}
): string => {
  const baseParams: Record<string, unknown> = {
    limit,
    offset,
    order,
    orderBy: orderBy ?? options.defaultOrderBy
  };

  const baseQuery = queryString.stringify(baseParams, {
    skipNull: true,
    skipEmptyString: true
  });

  const filterQuery = filters?.length ? createFilterQueryString(filters) : '';

  if (baseQuery && filterQuery) {
    return `?${baseQuery}&${filterQuery}`;
  }

  if (baseQuery) {
    return `?${baseQuery}`;
  }

  if (filterQuery) {
    return `?${filterQuery}`;
  }

  return '';
};

export { generateStringWithQueryParams };
